import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useSingleClickEditing } from '../../../hooks/DataGrid';
import { ComponentMode } from '../../../types';
import { DataGridRadioColumn } from '../../../util/DataGrid/DataGridHelpers';
import { defaulColumnVisibilityModel } from '../../../v2/components/generic/ObjectsDataTable/fns';
import { viewDefinitionToGridColumnMap } from '../../../v2/components/generic/transformFns';
import { GroupViewDefinition } from '../../SytemManagement/Devices/DeviceGatewayGroupViewSubParts';
import { StripedDataGrid } from '../DataGrid';
/** Takes a list of items and displays them
 * Differs from SimpleList in that it can be extended via normal datagrid props. Also does some automatic handling of styling and object selection + will construct columns out of a view def if no columns are provided
 * See also {@link SimpleList | ./useSimpleList.tsx}
 * */
export const useFlexibleList = (props) => {
    const { listItems, viewDefinition, columnOverrides, editOverride, ...dataGridPropsIn } = props;
    const columnMap = { ...viewDefinitionToGridColumnMap(viewDefinition ?? GroupViewDefinition, true) };
    const processedColumns = useMemo(() => {
        let cols = dataGridPropsIn.columns ? [...dataGridPropsIn.columns] : Object.entries(columnMap).map(([k, v]) => ({ field: k, ...v }));
        if (props.checkboxSelection) {
            cols.unshift(DataGridRadioColumn);
        }
        if (columnOverrides) {
            const overriddenCols = [];
            for (const col of cols) {
                overriddenCols.push(columnOverrides[col.field] ?? col);
            }
            cols = overriddenCols;
        }
        if (editOverride !== ComponentMode.EDIT) {
            cols = cols.map((c) => ({ ...c, editable: false }));
        }
        return cols;
    }, [columnMap, props.checkboxSelection]);
    /** Selectable Objects, if it's turned on */
    const [selectedObjects, setSelectedObjects] = useState([]);
    const updateItemSelection = (rowIds, details) => {
        const selectedIds = 'ids' in rowIds ? Array.from(rowIds.ids) : rowIds;
        let newSelectedObjects = selectedIds.map((id) => details.api.getRow(id)).filter((x) => Boolean(x));
        setSelectedObjects(newSelectedObjects);
        if (props.updatedItemSelectionCallback) {
            props.updatedItemSelectionCallback(rowIds, details, newSelectedObjects);
        }
    };
    const singleClickEditing = useSingleClickEditing();
    /** Assemble Data Grid Props */
    // Custom props will override defaults except for rows and columns
    const dataGridProps = {
        columnVisibilityModel: defaulColumnVisibilityModel,
        getRowClassName: (params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'),
        //initialState: {
        //  sorting: {
        //    sortModel: initialSort,
        //  },
        //},
        density: 'compact',
        checkboxSelection: false,
        ...singleClickEditing,
        ...dataGridPropsIn,
        onRowSelectionModelChange: (a, b) => {
            updateItemSelection(a, b);
        },
        columns: processedColumns,
        rows: listItems,
    };
    return {
        selectedObjects,
        component: _jsx(StripedDataGrid, { style: { fontSize: 'inherit' }, autoHeight: true, ...dataGridProps }),
    };
};
